import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import InfoDetail from "./Components/InfoDetail";
import FirmOwnerSection from "./Components/FirmOwnerSection";
import { toast } from "react-toastify";
import { CustomButton, HumbeeTabs } from "../../../v2/MUI_custom_component";
import HumbeeModal from "../../../v2/MUI_custom_component/Modal/HumbeeModal";
import { getUserFirmsAction } from "../../../v2/MyAccount/APIs/action";
import {
  deleteLeadGeneratedAction,
  deleteMRMAction,
  updateMRMAction,
} from "./API/Action";
import { toCapitalized } from "../../../v2/Utils/Capitalize";
import StatusBadge from "../../../v2/MUI_custom_component/Badge/StatusBadge";
import IconReusable from "../../../components/IconReusable";
import { useDispatch, useSelector } from "react-redux";
import EditRole from "./Components/EditRole";
import { MRMRequestType, REMARK_REQUEST_STATUS, STATUS } from "./Enums";
import IllustrationWrapper from "../../Illustrration/IllustrationWrapper";
import NoInventorySvg from "../../Illustrration/components/NoInventorySvg";
import GlassModal from "../../../v2/MUI_custom_component/Modal/GlassModal";
import { AddEmployeeModal } from "../Employee/AddEmployeeModal";
import { getOwnerDetailsAction } from "../Employee/API/Action";
import { EMPLOYEE_TYPES_ENUM } from "../Employee/Enum";
import { WhatsAppSection } from "../Employee/Components/WhatsAppSection";
import successLottie from "./../../../utils/Lottie/NewSuccess.json";
import DataLostSvg from "../../Illustrration/components/DataLostSvg";

const Firms = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [firms, setFirms] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [ownerList, setOwnerList] = useState({});
  const isMobile = useMediaQuery("(max-width: 1200px)");
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMRM, setSelectedMRM] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddOwnerModal, setShowAddOwnerModal] = useState(false);
  const [ownerWhatsappVerification, setOwnerWhatsappVerification] = useState({
    open: false,
    ownerId: null,
    firmId: null,
  });
  const preferredSelectedFirmId = useSelector(
    (state) => state.firmsReducer.selected_firm,
  );
  const selectedFirmId =
    firms && firms.length > 0 && firms[activeTab]
      ? firms[activeTab].firm_id
      : null;
  const [editContext, setEditContext] = useState({
    firm: null,
    company: null,
  });
  useEffect(() => {
    if (selectedFirmId) {
      dispatch({ type: "SET_SELECTED_FIRM", payload: selectedFirmId });
    }
  }, [selectedFirmId]);
  const fetchFirms = async () => {
    dispatch({ type: "RESET_FIRM_ONBOARDING" });
    setLoading(true);
    const { data, error, message } = await getUserFirmsAction();
    if (error) {
      toast.error(message);
      setLoading(false);
      return;
    }
    setFirms((prevFirms) => {
      const prevFirmIds = new Set(
        (prevFirms || []).map((firm) => firm.firm_id),
      );
      const addedFirmIndex = (data || []).findIndex(
        (firm) => !prevFirmIds.has(firm.firm_id),
      );
      const preferredFirmIndex = (data || []).findIndex(
        (firm) => String(firm.firm_id) === String(preferredSelectedFirmId),
      );

      setActiveTab((prevTab) => {
        if (!data || data.length === 0) {
          return 0;
        }

        if (preferredFirmIndex !== -1) {
          return preferredFirmIndex;
        }

        if (addedFirmIndex !== -1 && data.length > (prevFirms || []).length) {
          return addedFirmIndex;
        }

        return Math.min(prevTab, data.length - 1);
      });

      return data;
    });
    setLoading(false);
    // if (data && data.length > 0) {
    //   const currentTab = data.length === 0 ? 0 : Math.min(activeTab, data.length - 1);
    //   const firmId = data[currentTab]?.firm_id;
    //   if (firmId) {
    //     fetchOwners(firmId);
    //   }
    // }
  };

  const fetchOwners = async (selectedFirmId) => {
    setLoading(true);
    const { data, error, message } =
      await getOwnerDetailsAction(selectedFirmId);
    setLoading(false);
    if (!error) {
      setOwnerList(data?.owner_list);
    } else {
      toast.error(message || "Unable to fetch firm details");
      return;
    }
  };
  useEffect(() => {
    fetchFirms();
  }, []);
  useEffect(() => {
    if (selectedFirmId) {
      fetchOwners(selectedFirmId);
    }
  }, [selectedFirmId]);

  const handleManufacturerAdd = (selectedFirmData) => {
    dispatch({ type: "RESET_FIRM_ONBOARDING" });
    dispatch({ type: "SET_EXISTING_FIRM", payload: true });
    const gstDetails = {
      gst_number:
        selectedFirmData?.firm_gstin || selectedFirmData?.firm_gstin || null,
      pan_number:
        selectedFirmData?.firm_pan || selectedFirmData?.firm_pan || null,
      firm_name:
        selectedFirmData?.firm_name || selectedFirmData?.firm_name || null,
      address_line_1: selectedFirmData?.address?.address_line_1 || null,
      address_line_2: selectedFirmData?.address?.address_line_2 || null,
      state_id: selectedFirmData?.address?.state_id || null,
      state_name: selectedFirmData?.address?.state_name || null,
      pincode_id: selectedFirmData?.address?.pincode || null,
      district_id: selectedFirmData?.address?.district_id || null,
      district_name: selectedFirmData?.address?.district_name || null,
      location_id: selectedFirmData?.address?.location_id || null,
      location_name: selectedFirmData?.address?.location_name || null,
    };
    dispatch({ type: "SET_GST_DETAILS", payload: gstDetails });
    dispatch({ type: "SET_OPERATIONAL_DETAILS", payload: gstDetails });
    dispatch({ type: "SET_GST_NUMBER", payload: gstDetails.gst_number });
    navigate("/my-account/add-manufacturer");
  };
  const handeleAddFirm = () => {
    dispatch({
      type: "RESET_FIRM_ONBOARDING_REDUCER",
    });
    dispatch({
      type: "RESET_SELECTED_FIRM",
    });
    dispatch({ type: "RESET_FIRM_ONBOARDING" });
    dispatch({ type: "RESET_MANUFACTURER_ROLE_FLOW" });
    navigate("/my-account/add-manufacturer");
  };
  const handleDeleteRole = (
    manufacturer_role_map_id,
    type,
    lead_generation_id,
  ) => {
    setSelectedMRM({
      lead_generation_id,
      manufacturer_role_map_id,
      request_type: type || null,
    });
    setShowDeleteModal(true);
  };

  // Shared delete logic for both delete and cancel actions
  const performDelete = async (
    { lead_generation_id, manufacturer_role_map_id, request_type },
    afterDelete,
  ) => {
    if (lead_generation_id) {
      const { error, message } =
        await deleteLeadGeneratedAction(lead_generation_id);
      if (!error) {
        toast.success(message);
        fetchFirms();
        if (afterDelete) afterDelete();
      } else {
        toast.error(message);
      }
      return;
    }
    if (!manufacturer_role_map_id) {
      return;
    }
    const payload = {
      manufacturer_role_map_id,
      request_type,
    };
    const { error, message } = await deleteMRMAction(payload);
    if (!error) {
      toast.success(message);
      // fetchSuppliers();
      fetchFirms();
      if (afterDelete) afterDelete();
    } else {
      toast.error(message);
    }
  };

  // Directly cancel request without showing modal
  const handleCancelRequest = (
    manufacturer_role_map_id,
    type,
    lead_generation_id,
  ) => {
    performDelete({
      lead_generation_id,
      manufacturer_role_map_id,
      request_type: type,
    });
  };
  const onConfirmDelete = async () => {
    setShowDeleteModal(false);
    if (!selectedMRM) return;
    performDelete(selectedMRM, () => setSelectedMRM(null));
  };
  const handleOpenEditRole = (company, firm) => {
    setEditContext({ company, firm });
    if (company.is_edit_message) {
      toast.error(company.is_edit_message);
      return;
    } else {
      setShowEditModal(true);
    }
  };
  const handleCloseEditRole = () => {
    setShowEditModal(false);
    setEditContext({ firm: null, company: null });
  };

  const handleSubmitEditRole = async (payload) => {
    const { data, error, message } = await updateMRMAction(payload);
    if (error) {
      toast.error(message);
    } else {
      toast.success(message);
      handleCloseEditRole();
      fetchFirms();
    }
  };
  const handleOpenAddOwnerModal = (firmId) => {
    setShowAddOwnerModal(true);
  };
  const handleCloseAddOwnerModal = () => {
    setShowAddOwnerModal(false);
    fetchFirms();
    fetchOwners(selectedFirmId);
  };

  const handleOwnerAddedRequiresWhatsapp = ({ ownerId, firmId }) => {
    setShowAddOwnerModal(false);
    setOwnerWhatsappVerification({
      open: true,
      ownerId,
      firmId: firmId || selectedFirmId,
    });
  };

  const handleCloseOwnerWhatsappVerification = () => {
    setOwnerWhatsappVerification({
      open: false,
      ownerId: null,
      firmId: null,
    });
    fetchFirms();
    fetchOwners(selectedFirmId);
  };

  return (
    <>
      <Box sx={{ px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 } }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}>
            <Typography variant="body1">
              Would you like to add another firm?
            </Typography>
            <CustomButton
              variant="contained"
              color="primary"
              label="Add Firm"
              size={isMobile ? "small" : "medium"}
              onClick={() => handeleAddFirm()}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              gap: 1,
            }}>
            <Typography variant="h1">Firms</Typography>
          </Box>
          {loading && (
            <Box
              sx={{
                py: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <CircularProgress size={28} sx={{ color: "#995A00" }} />
            </Box>
          )}
          {!loading && firms.length === 0 && (
            <Typography variant="body1">No firm details found.</Typography>
          )}
          {!loading && firms.length > 0 && (
            <HumbeeTabs
              data={firms}
              tabVariant={isMobile ? "small" : "default"}
              currentTab={activeTab}
              onChange={(_, value) => setActiveTab(value)}
              getTabKey={(firm) => firm.firm_id}
              getTabLabel={(firm) => firm.firm_name}
              tabType="dashed"
              variant="scrollable"
              scrollVisible={isMobile && 3}
              renderTabContent={(firm) => (
                <Box sx={{ pt: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                    }}>
                    <Box
                      sx={{
                        flex: { xs: "1 1 100%", md: "1 1 calc(50% - 8px)" },
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#FFF",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 1, md: 2 },
                      }}>
                      <Typography variant="labelD">
                        Business Information
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}>
                        {firm.firm_gstin && (
                          <InfoDetail
                            label="GSTIN"
                            value={firm.firm_gstin}
                            width={{ xs: "100%", md: "80%" }}
                            rowLabelMinWidth={{ xs: "40%", md: "32%" }}
                            alignItems="flex-start"
                          />
                        )}
                        {!firm.firm_gstin && firm.firm_pan && (
                          <InfoDetail
                            label="PAN"
                            value={firm.firm_pan}
                            width={{ xs: "100%", md: "80%" }}
                            rowLabelMinWidth={{ xs: "40%", md: "32%" }}
                            alignItems="flex-start"
                          />
                        )}
                        {firm.firm_name && (
                          <InfoDetail
                            label="Firm Name"
                            value={firm.firm_name}
                            width={{ xs: "100%", md: "80%" }}
                            rowLabelMinWidth={{ xs: "40%", md: "32%" }}
                            alignItems="flex-start"
                          />
                        )}
                        <InfoDetail
                          label="Firm Type"
                          value={firm.firm_type}
                          width={{ xs: "100%", md: "80%" }}
                          rowLabelMinWidth={{ xs: "40%", md: "32%" }}
                          alignItems="flex-start"
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        flex: { xs: "1 1 100%", md: "1 1 calc(50% - 8px)" },
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#FFF",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}>
                      <Typography variant="labelD">Address</Typography>

                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography variant="body1">
                          {firm?.address.address_line_1},{" "}
                          {firm.address.address_line_2}
                        </Typography>
                        <Typography variant="body1">
                          {firm?.address.location_name},{" "}
                          {firm.address.district_name}
                        </Typography>
                        <Typography variant="body1">
                          {firm?.address.state_name}, {firm.address.pincode}
                        </Typography>
                      </Box>
                    </Box>

                    {!(firm.owners?.length === 0 && ownerList?.length === 0) && (
                      <FirmOwnerSection
                        firmId={firm.firm_id}
                        owners={firm.owners}
                        onAddOwner={() => handleOpenAddOwnerModal(firm.firm_id)}
                        onWhatsappVerified={fetchFirms}
                        ownerList={ownerList}
                      />
                    )}
                    <Box
                      sx={{
                        flex: { xs: "1 1 100%", md: "1 1 calc(60% - 8px)" },
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#FFF",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: 1,
                        }}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Typography variant="overline">
                            dealerships
                          </Typography>
                          <Typography variant="h3">
                            Manufacturers & Roles
                          </Typography>
                        </Box>
                        <CustomButton
                          variant="contained"
                          color="primary"
                          label="Add Manufacturer"
                          size={isMobile ? "small" : "medium"}
                          onClick={() => handleManufacturerAdd(firm)}
                        />
                      </Box>

                      {!firm.dealership_companies.length && (
                        <Box>
                          <IllustrationWrapper
                            titleVariant="h3"
                            subtitleVariant="body1"
                            subtitleStyle={{ color: "#666" }}
                            illustration={<NoInventorySvg />}
                            illustrationProps={{
                              width: 160,
                              height: 132,
                            }}
                          />
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}>
                        {firm.dealership_companies.map((company) => {
                          const status = company?.status;
                          const normalizedStatus = company?.status || "";
                          const normalizedRequestStatus =
                            company?.request_status;
                          const isRequestStatusNull =
                            company?.request_status === null;
                          let remarkColor = "#666";
                          let remarkIcon = null;
                          if (
                            isRequestStatusNull &&
                            normalizedStatus === STATUS.TERMINATED
                          ) {
                            remarkColor = "#CC0000";
                            remarkIcon = "InfoOutlined";
                          } else if (isRequestStatusNull) {
                            remarkColor = "#666";
                            remarkIcon = null;
                          } else if (
                            normalizedRequestStatus ===
                            REMARK_REQUEST_STATUS.ACCEPT
                          ) {
                            remarkColor = "#008000";
                            remarkIcon = "CheckCircle";
                          } else if (
                            normalizedRequestStatus ===
                            REMARK_REQUEST_STATUS.REJECT
                          ) {
                            remarkColor = "#CC0000";
                            remarkIcon = "InfoOutlined";
                          }
                          const isDeleteDisabled =
                            company.request_sent === MRMRequestType.DELETE &&
                            company.request_status === null;
                          return (
                            <Box
                              key={company.manufacturer_role_map_id}
                              sx={{
                                borderTop: "1px solid #EEE",
                                pt: { xs: 1, md: 2 },
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                              }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: 1,
                                }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                  }}>
                                  <Box
                                    component="img"
                                    src={company.manufacturer_logo_url}
                                    alt={company.manufacturer_name}
                                    sx={{
                                      width: 48,
                                      height: 48,
                                      objectFit: "contain",
                                      borderRadius: 2,
                                      backgroundColor: "#FFF",
                                      border: "1px solid #D9D9D9",
                                    }}
                                  />
                                  <Box>
                                    <Typography variant="bodyM">
                                      {company.manufacturer_name}
                                    </Typography>
                                    <Typography
                                      variant="p3"
                                      color="text.secondary">
                                      {toCapitalized(company.firm_role_name)}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}>
                                  {status && (
                                    <StatusBadge
                                      label={status}
                                      status={status}
                                      size={isMobile ? "small" : "medium"}
                                    />
                                  )}

                                  {company.is_delete && (
                                    <Box
                                      onClick={
                                        isDeleteDisabled
                                          ? undefined
                                          : () =>
                                              handleDeleteRole(
                                                company.manufacturer_role_map_id,
                                                null,
                                                company.lead_generation_id,
                                              )
                                      }
                                      sx={{
                                        cursor: isDeleteDisabled
                                          ? "not-allowed"
                                          : "pointer",
                                        pointerEvents: isDeleteDisabled
                                          ? "none"
                                          : "auto",
                                        color: isDeleteDisabled ? '#E5E5E5' : "#333333",
                                      }}
                                    >
                                      <IconReusable
                                        name="Delete"
                                        color={isDeleteDisabled ? "#E5E5E5" : "#333333"}
                                        size={isMobile ? 16 : 24}
                                      />
                                    </Box>
                                  )}
                                  {company.is_edit && (
                                    <IconButton
                                      onClick={() =>
                                        handleOpenEditRole(company, firm)
                                      }
                                      sx={{
                                        cursor: "pointer",
                                        color:"#666",
                                      }}
                                      >
                                      <IconReusable
                                        name="Edit"
                                        color="#666"
                                        size={isMobile ? 16 : 24}
                                      />
                                    </IconButton>
                                  )}
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: 1,
                                }}>
                                {!!company.remark && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}>
                                    {!!remarkIcon && (
                                      <IconReusable
                                        name={remarkIcon}
                                        color={remarkColor}
                                        size={isMobile ? 14 : 16}
                                      />
                                    )}
                                    <Typography
                                      variant="body1"
                                      sx={{ color: remarkColor }}>
                                      {company.remark}
                                    </Typography>
                                  </Box>
                                )}
                                {!isMobile && company.is_cancel && (
                                  <CustomButton
                                    variant="text"
                                    color="primary"
                                    label="Cancel Request"
                                    onClick={() =>
                                      handleCancelRequest(
                                        company.manufacturer_role_map_id,
                                        company.request_sent,
                                        company.lead_generation_id,
                                      )
                                    }
                                  />
                                )}
                              </Box>
                              {isMobile && company.is_cancel && (
                                <CustomButton
                                  variant="text"
                                  color="primary"
                                  label="Cancel Request"
                                  size="small"
                                  onClick={() =>
                                    handleCancelRequest(
                                      company.manufacturer_role_map_id,
                                      company.request_sent,
                                      company.lead_generation_id,
                                    )
                                  }
                                />
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
            />
          )}
        </Box>
      </Box>
      <HumbeeModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={onConfirmDelete}
        loading={loading}
        title="Are you sure you want to delete this dealership?"
        subtitle="You can add manufacturer again via “Add Manufacturer” button in Dealerships section.
      "
        confirmLabel="Yes"
        cancelLabel="No"
        illustration={<DataLostSvg />}
        width={{ xs: 400, md: 400 }}
      />
      <EditRole
        open={showEditModal}
        onClose={handleCloseEditRole}
        onSubmit={handleSubmitEditRole}
        company={editContext.company}
        firm={editContext.firm}
        loading={loading}
      />
      <GlassModal
        open={showAddOwnerModal}
        onClose={handleCloseAddOwnerModal}
        title="Add Owner"
        scrollable={true}
        maxWidth="600px">
        <AddEmployeeModal
          firmID={selectedFirmId}
          onClose={handleCloseAddOwnerModal}
          defaultRole={EMPLOYEE_TYPES_ENUM.OWNER}
          allowedRoles={[
            {
              label: toCapitalized(EMPLOYEE_TYPES_ENUM.OWNER),
              value: EMPLOYEE_TYPES_ENUM.OWNER,
            },
          ]}
          fetchEmployeeDetails={() => fetchOwners(selectedFirmId)}
          onOwnerAddedRequiresWhatsapp={handleOwnerAddedRequiresWhatsapp}
        />
      </GlassModal>
      <GlassModal
        open={ownerWhatsappVerification.open}
        onClose={handleCloseOwnerWhatsappVerification}
        title="Verify WhatsApp Number"
        scrollable={true}
        maxWidth="600px"
        showHeader={false}
        keepMounted={true}
        keepContentMounted={true}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 2, md: 2 },
            width: "100%",
          }}>
          <Box
            sx={{
              textAlign: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}>
            <IllustrationWrapper
              titleVariant="h1"
              subtitleVariant="body1"
              animationData={successLottie}
              loop={false}
              onClose={handleCloseOwnerWhatsappVerification}
              title="Successful!"
              subtitle={"Owner added successfully."}
            />
          </Box>
          <WhatsAppSection
            is_whatsapp_same={false}
            OwnerWhatsappNumber={null}
            ownerKey={ownerWhatsappVerification.ownerId}
            labelDirection="column"
            firmId={ownerWhatsappVerification.firmId || selectedFirmId}
            isEditable={true}
            onWhatsappVerified={handleCloseOwnerWhatsappVerification}
            verifyWhatsappProps={{
              showMobileNumber: true,
              showText: true,
              containerSx: {
                width: "100%",
                alignItems: "center",
                gap: 1,
              },
              textFieldSx: {
                width: "100%",
                "& legend": { textAlign: "left" },
                "& .MuiTypography-root": { textAlign: "left" },
              },
              showActionButtons: true,
              cancelLabel: "Cancel",
              verifyLabel: "Verify",
              onCancel: handleCloseOwnerWhatsappVerification,
              onOpenVerifyModal: () =>
                setOwnerWhatsappVerification({
                  open: false,
                  ownerId: ownerWhatsappVerification.ownerId,
                  firmId: ownerWhatsappVerification.firmId,
                }),
            }}
          />
        </Box>
      </GlassModal>
    </>
  );
};

export default Firms;
